const SCALE = 10_000n;

const BUILDING_GROWTH_BASIS_POINTS = {
	hq: 12_700,
	farm: 12_500,
	mine: 12_500,
	mana: 12_500,
	warehouse: 12_600,
	barracks: 12_800,
	stable: 12_500,
	stables: 12_500,
	siege: 12_500,
	wall: 11_700,
	market: 13_000,
	hiding_place: 12_500,
};

function powScaled(baseBasisPoints, exp) {
	let result = SCALE;
	const base = BigInt(baseBasisPoints);
	for (let i = 0; i < exp; i += 1) {
		result = result * base / SCALE;
	}
	return result;
}

function scaledFloor(value, multiplier) {
	return Number(BigInt(value) * multiplier / SCALE);
}

function normalizeBuildingName(buildingName) {
	return buildingName === "stables" ? "stable" : buildingName;
}

function calculateBuildingUpgradeTime(hqLevel, buildingLevel, baseTime) {
	const multiplier = powScaled(12_000, buildingLevel);
	const hqDivisor = powScaled(10_500, hqLevel);
	return Number(BigInt(baseTime) * multiplier / hqDivisor);
}

function calculateBuildingUpgradeCost(buildingName, base, currentLevel, hqLevel) {
	const level = Math.max(currentLevel, 0);
	const growthBasisPoints = BUILDING_GROWTH_BASIS_POINTS[normalizeBuildingName(buildingName)];
	if (!growthBasisPoints) {
		throw new Error(`Unknown building growth rate for ${buildingName}`);
	}

	const growthMulti = powScaled(growthBasisPoints, level);
	const populationMulti = powScaled(10_800, level);

	return {
		population: scaledFloor(base.population, populationMulti),
		gold: scaledFloor(base.gold, growthMulti),
		mana: scaledFloor(base.mana, growthMulti),
		food: scaledFloor(base.food, growthMulti),
		base_upgrade_blocks: calculateBuildingUpgradeTime(hqLevel, level, base.base_upgrade_blocks),
		growth_rate: Number(growthMulti) / Number(SCALE),
	};
}

module.exports = {
	BUILDING_GROWTH_BASIS_POINTS,
	SCALE,
	calculateBuildingUpgradeCost,
	calculateBuildingUpgradeTime,
	powScaled,
};
